/**
 * Runtime domain detection for dev vs prod environments.
 * Since dev and prod share the same Vercel project (and env vars),
 * we detect the environment from the hostname at runtime.
 */

export const isDev = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.startsWith('dev.');
};

export const getAppUrl = (): string => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:8083';
  return isDev() ? 'https://dev.app.jamsom.com' : 'https://app.jamsom.com';
};

export const getFrontendUrl = (): string => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:3000';
  return isDev() ? 'https://dev.jamsom.com' : 'https://jamsom.com';
};
